/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { Bundles, BundlesInterface } from "../Bundles";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "Ownable_NewOwnerCannotBeAddressZero",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "Ownable_SenderIsNotOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bundleId",
        type: "uint256",
      },
    ],
    name: "TokenBundleFactory_BundleHasNoPacks",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bundleId",
        type: "uint256",
      },
    ],
    name: "TokenBundleFactory_BundleInactive",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bundleId",
        type: "uint256",
      },
    ],
    name: "TokenBundleFactory_BundleNotFound",
    type: "error",
  },
  {
    inputs: [],
    name: "TokenBundleFactory_LimitReached",
    type: "error",
  },
  {
    inputs: [],
    name: "TokenBundleFactory_LimitResetStartTimeRequired",
    type: "error",
  },
  {
    inputs: [],
    name: "TokenBundleFactory_ZeroAddress",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "bundleId",
        type: "uint256",
      },
    ],
    name: "BundleCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "bundleId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "BundlePurchased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "bundleId",
        type: "uint256",
      },
    ],
    name: "BundleUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "newValue",
        type: "bool",
      },
    ],
    name: "OperatorToggled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "projectToken",
            type: "bool",
          },
          {
            internalType: "address",
            name: "priceToken",
            type: "address",
          },
          {
            internalType: "uint88",
            name: "priceAmount",
            type: "uint88",
          },
          {
            internalType: "uint16",
            name: "limitCount",
            type: "uint16",
          },
          {
            internalType: "uint40",
            name: "limitIntervalSeconds",
            type: "uint40",
          },
          {
            internalType: "uint40",
            name: "limitResetStartTime",
            type: "uint40",
          },
          {
            internalType: "uint16",
            name: "limitCountPerAddress",
            type: "uint16",
          },
          {
            internalType: "uint40",
            name: "limitIntervalSecondsPerAddress",
            type: "uint40",
          },
          {
            internalType: "uint40",
            name: "limitResetStartTimePerAddress",
            type: "uint40",
          },
          {
            components: [
              {
                internalType: "address",
                name: "stakingContract",
                type: "address",
              },
              {
                internalType: "uint128",
                name: "primaryTokenQuantity",
                type: "uint128",
              },
              {
                internalType: "uint128",
                name: "secondaryTokenQuantity",
                type: "uint128",
              },
            ],
            internalType: "struct ITokenBundleFactory.PackItem[]",
            name: "packs",
            type: "tuple[]",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
        ],
        internalType: "struct ITokenBundleFactory.Bundle",
        name: "bundle",
        type: "tuple",
      },
    ],
    name: "createBundle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bundleId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getAvailableLimitsForBundle",
    outputs: [
      {
        internalType: "uint256",
        name: "globalRemaining",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "globalTimeToReset",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "localRemaining",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "localTimeToReset",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bundleId",
        type: "uint256",
      },
    ],
    name: "getBundle",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "projectToken",
            type: "bool",
          },
          {
            internalType: "address",
            name: "priceToken",
            type: "address",
          },
          {
            internalType: "uint88",
            name: "priceAmount",
            type: "uint88",
          },
          {
            internalType: "uint16",
            name: "limitCount",
            type: "uint16",
          },
          {
            internalType: "uint40",
            name: "limitIntervalSeconds",
            type: "uint40",
          },
          {
            internalType: "uint40",
            name: "limitResetStartTime",
            type: "uint40",
          },
          {
            internalType: "uint16",
            name: "limitCountPerAddress",
            type: "uint16",
          },
          {
            internalType: "uint40",
            name: "limitIntervalSecondsPerAddress",
            type: "uint40",
          },
          {
            internalType: "uint40",
            name: "limitResetStartTimePerAddress",
            type: "uint40",
          },
          {
            components: [
              {
                internalType: "address",
                name: "stakingContract",
                type: "address",
              },
              {
                internalType: "uint128",
                name: "primaryTokenQuantity",
                type: "uint128",
              },
              {
                internalType: "uint128",
                name: "secondaryTokenQuantity",
                type: "uint128",
              },
            ],
            internalType: "struct ITokenBundleFactory.PackItem[]",
            name: "packs",
            type: "tuple[]",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
        ],
        internalType: "struct ITokenBundleFactory.Bundle",
        name: "bundle",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bundleId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getRemainingInInterval",
    outputs: [
      {
        internalType: "uint256",
        name: "remaining",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "timeToReset",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bundleId",
        type: "uint256",
      },
    ],
    name: "getRemainingInInterval",
    outputs: [
      {
        internalType: "uint256",
        name: "remaining",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "timeToReset",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "referralContract_",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isOperator",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "cDatas",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bundleId",
        type: "uint256",
      },
    ],
    name: "purchaseBundle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "referralContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "referrer",
        type: "address",
      },
    ],
    name: "registerReferral",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "refContract",
        type: "address",
      },
    ],
    name: "setReferralContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "toggleOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bundleId",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "limitCount",
        type: "uint16",
      },
    ],
    name: "updateLimitCount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bundleId",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "limitCountPerAddress",
        type: "uint16",
      },
    ],
    name: "updateLimitCountPerAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bundleId",
        type: "uint256",
      },
      {
        internalType: "uint40",
        name: "limitIntervalSeconds",
        type: "uint40",
      },
      {
        internalType: "uint40",
        name: "limitResetStartTime",
        type: "uint40",
      },
    ],
    name: "updateLimitIntervalSecondsAndStartTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bundleId",
        type: "uint256",
      },
      {
        internalType: "uint40",
        name: "limitIntervalSecondsPerAddress",
        type: "uint40",
      },
      {
        internalType: "uint40",
        name: "limitResetStartTimePerAddress",
        type: "uint40",
      },
    ],
    name: "updateLimitIntervalSecondsAndStartTimePerAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bundleId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "address",
            name: "stakingContract",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "primaryTokenQuantity",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "secondaryTokenQuantity",
            type: "uint128",
          },
        ],
        internalType: "struct ITokenBundleFactory.PackItem[]",
        name: "packs",
        type: "tuple[]",
      },
    ],
    name: "updatePacks",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bundleId",
        type: "uint256",
      },
      {
        internalType: "uint88",
        name: "priceAmount",
        type: "uint88",
      },
    ],
    name: "updatePriceAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "bundleId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "projectToken",
        type: "bool",
      },
      {
        internalType: "address",
        name: "priceToken",
        type: "address",
      },
      {
        internalType: "uint88",
        name: "priceAmount",
        type: "uint88",
      },
    ],
    name: "updateToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class Bundles__factory {
  static readonly abi = _abi;
  static createInterface(): BundlesInterface {
    return new Interface(_abi) as BundlesInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): Bundles {
    return new Contract(address, _abi, runner) as unknown as Bundles;
  }
}
